import React from "react";
import BlockRenderer from "../blocks/BlockRenderer";

const LessonScreen = ({
                          screen,
                          completedBlocks = new Set(),
                          onBlockComplete
                      }) => {
    if (!screen) {
        return null;
    }

    console.log(
        "RENDERING SCREEN:",
        screen.id,
        "fragment:",
        screen.fragmentId,
        "blocks:",
        screen.blocks.map((b) => b.id)
    );

    return (
        <div className="w-full max-w-3xl mx-auto px-4 py-8">
            <div className="flex flex-col gap-6">
                {screen.blocks.map((block) => (
                    <BlockRenderer
                        key={block.id}
                        block={block}
                        completed={completedBlocks.has(block.id)}
                        onComplete={() => onBlockComplete(block.id)}
                    />
                ))}
            </div>
        </div>
    );
};

export default LessonScreen;